module.exports = __webpack_public_path__ + "static/media/network.4ef0e478.png";